// import { RequestProxyUrl } from './imageUrl';

export async function createColoredImage(width, height, color) {
    const canvas = document.createElement('canvas');
    canvas.width = width;
    canvas.height = height;
  
    const context = canvas.getContext('2d');
    context.fillStyle = color;
    context.fillRect(0, 0, width, height);
  
    return await canvas.toDataURL('image/png');
}

export async function removeBackgroundColor(imageUrl, fillColor, colorTolerance) {
    const canvas = document.createElement('canvas');
    const context = canvas.getContext("2d", { willReadFrequently: true }); 

    const img = new Image();
    img.crossOrigin = 'anonymous';
    img.src = imageUrl;
    //img.src = RequestProxyUrl(imageUrl);

    return new Promise((resolve, reject) => {
      img.onload = async function() {
        canvas.width = img.width;
        canvas.height = img.height;
        context.drawImage(img, 0, 0);
  
        const imageData = context.getImageData(0, 0, canvas.width, canvas.height);
  
        floodFillWithBoundary(0, 0, fillColor, { r: 0, g: 0, b: 0, a: 255 }, imageData, canvas, colorTolerance);
  
        context.putImageData(imageData, 0, 0);
  
        resolve(await canvas.toDataURL());
      };

      img.onerror = (error) => {
        reject(new Error(`Failed to load image. Reason: ${error.message}`));
      };
    });
}

//===============================
// internal utility functions
//===============================
const isColorMatch = (color1, color2, colorTolerance) => {
    return Math.abs(color1.r - color2.r) <= colorTolerance &&
           Math.abs(color1.g - color2.g) <= colorTolerance &&
           Math.abs(color1.b - color2.b) <= colorTolerance &&
           Math.abs(color1.a - color2.a) <= colorTolerance;
};

const floodFillWithBoundary = (x, y, fillColor, boundaryColor, imageData, canvas, colorTolerance) => {
    const index = (y * canvas.width + x) * 4;
  
    const targetColor = {
      r: imageData.data[index],
      g: imageData.data[index + 1],
      b: imageData.data[index + 2],
      a: imageData.data[index + 3],
    };     

    if (isColorMatch(targetColor, boundaryColor, colorTolerance)) {
      // Pixel already has the fill color
      return;
    }

    const stack = [{ x, y }];
    while (stack.length) {
      const { x, y } = stack.pop();
      const index = (y * canvas.width + x) * 4;
      const pixelColor = {
        r: imageData.data[index],
        g: imageData.data[index + 1],
        b: imageData.data[index + 2],
        a: imageData.data[index + 3],
      };

      if (isColorMatch(pixelColor, fillColor)) {
        // Pixel already has the fill color
        continue;
      }

      if (!isColorMatch(pixelColor, targetColor, colorTolerance)) {
        // Pixel is not the target color
        continue;
      }

      imageData.data[index] = fillColor.r;
      imageData.data[index + 1] = fillColor.g;
      imageData.data[index + 2] = fillColor.b;
      imageData.data[index + 3] = fillColor.a;

      if (x > 0) {
        stack.push({ x: x - 1, y });
      }
      if (x < canvas.width - 1) {
        stack.push({ x: x + 1, y });
      }
      if (y > 0) {
        stack.push({ x, y: y - 1 });
      }
      if (y < canvas.height - 1) {
        stack.push({ x, y: y + 1 });
      }
    }
};


